/**
 * @generated SignedSource<<141e8afe30ac6898c08d6b7763f0a722>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
    [K in keyof T]: T[K];
  };
export enum AccessStatus {
  ANONYMOUS_ACCESS = "ANONYMOUS_ACCESS",
  EXTERNAL_COLLABORATOR_ACCESS = "EXTERNAL_COLLABORATOR_ACCESS",
  EXTERNAL_SHARE_ACCESS = "EXTERNAL_SHARE_ACCESS",
  LICENSED_ADMIN_ACCESS = "LICENSED_ADMIN_ACCESS",
  LICENSED_USE_ACCESS = "LICENSED_USE_ACCESS",
  NOT_PERMITTED = "NOT_PERMITTED",
  UNLICENSED_AUTHENTICATED_ACCESS = "UNLICENSED_AUTHENTICATED_ACCESS",
}
export enum ConfluenceEdition {
  FREE = "FREE",
  PREMIUM = "PREMIUM",
  STANDARD = "STANDARD",
}
export enum Environment {
  DEVELOPMENT = "DEVELOPMENT",
  STAGING = "STAGING",
  PRODUCTION = "PRODUCTION",
}
export type SiteInformationQuery_tenant_Tenant_editions_ConfluenceEditions =
  {
    __typename?: "ConfluenceEditions";
    edition: ConfluenceEdition;
  };
export type SiteInformationQuery_tenant_Tenant = {
  __typename?: "Tenant";
  shard: string;
  cloudId: string;
  environment: Environment;
  activationId: string | null;
  editions: SiteInformationQuery_tenant_Tenant_editions_ConfluenceEditions | null;
};
export type SiteInformationQuery_organization_Organization = {
  __typename?: "Organization";
  orgId: string | null;
};
export type SiteInformationQuery_userForAnalytics_AtlassianUser = {
  __typename?: "AtlassianUser";
  id: string | null;
};
export type SiteInformationQuery_user_AtlassianUser_confluence_ConfluenceUser =
  {
    __typename?: "ConfluenceUser";
    accessStatus: AccessStatus;
    accountId: string | null;
    userKey: string | null;
    locale: string;
  };
export type SiteInformationQuery_user_AtlassianUser = {
  __typename?: "AtlassianUser";
  id: string | null;
  displayName: string | null;
  timeZone: string | null;
  confluence: SiteInformationQuery_user_AtlassianUser_confluence_ConfluenceUser | null;
};
export type SiteInformationQuery_getAIConfig_AIConfigResponse = {
  __typename?: "AIConfigResponse";
  isEnabled: boolean;
  isRovoEnabled: boolean | null;
  isRovoLLMEnabled: boolean | null;
};
export type SiteInformationQuery_confluence_tenantContext_ConfluenceTenantContext_licenseStates_LicenseStates_confluence_LicenseState =
  {
    __typename?: "LicenseState";
    ccpEntitlementId: string | null;
  };
export type SiteInformationQuery_confluence_tenantContext_ConfluenceTenantContext_licenseStates_LicenseStates =
  {
    __typename?: "LicenseStates";
    confluence: SiteInformationQuery_confluence_tenantContext_ConfluenceTenantContext_licenseStates_LicenseStates_confluence_LicenseState | null;
  };
export type SiteInformationQuery_confluence_tenantContext_ConfluenceTenantContext =
  {
    __typename?: "ConfluenceTenantContext";
    timeZone: string | null;
    licenseStates: SiteInformationQuery_confluence_tenantContext_ConfluenceTenantContext_licenseStates_LicenseStates | null;
  };
export type SiteInformationQuery_siteSettings_SiteSettings_homepage_Homepage =
  {
    __typename?: "Homepage";
    uri: string | null;
    title: string | null;
  };
export type SiteInformationQuery_siteSettings_SiteSettings_frontCover_FrontCover =
  {
    __typename?: "FrontCover";
    frontCoverState: string | null;
  };
export type SiteInformationQuery_siteSettings_SiteSettings = {
  __typename?: "SiteSettings";
  siteTitle: string;
  showApplicationTitle: boolean;
  companyHubName: string | null;
  homepage: SiteInformationQuery_siteSettings_SiteSettings_homepage_Homepage | null;
  frontCover: SiteInformationQuery_siteSettings_SiteSettings_frontCover_FrontCover | null;
};
export type SiteInformationQuery_siteDescription_SiteDescription = {
  __typename?: "SiteDescription";
  logoUrl: string | null;
};
export type SiteInformationQuery_currentConfluenceUser_CurrentConfluenceUser =
  {
    __typename?: "CurrentConfluenceUser";
    isAnonymous: boolean;
  };
export type SiteInformationQuery_Query = {
  __typename?: "Query";
  isSiteAdmin: boolean;
  abTestCohorts: string;
  experimentFeatures: string | null;
  userCanCreateContent: boolean | null;
  isNewUser: boolean;
  tenant: SiteInformationQuery_tenant_Tenant;
  organization: SiteInformationQuery_organization_Organization | null;
  userForAnalytics: SiteInformationQuery_userForAnalytics_AtlassianUser | null;
  user: SiteInformationQuery_user_AtlassianUser | null;
  getAIConfig: SiteInformationQuery_getAIConfig_AIConfigResponse | null;
  confluence_tenantContext: SiteInformationQuery_confluence_tenantContext_ConfluenceTenantContext | null;
  siteSettings: SiteInformationQuery_siteSettings_SiteSettings | null;
  siteDescription: SiteInformationQuery_siteDescription_SiteDescription | null;
  currentConfluenceUser: SiteInformationQuery_currentConfluenceUser_CurrentConfluenceUser | null;
};
export type SiteInformationQueryVariables = Exact<{
  [key: string]: never;
}>;
export type SiteInformationQuery =
  SiteInformationQuery_Query;
